import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthService } from '../auth/auth.service';
import { CriticalCaseSeverity, CriticalCaseDetail, CriticalCaseFilters, CriticalCasePage } from './critical-case.models';

@Injectable({ providedIn: 'root' })
export class CriticalCaseService {
  private readonly http = inject(HttpClient);
  private readonly auth = inject(AuthService);

  private base(): string {
    return `/api/t/${this.auth.currentTenant()}/casos-criticos`;
  }

  list(filters: CriticalCaseFilters = {}): Observable<CriticalCasePage> {
    let params = new HttpParams();
    for (const [key, value] of Object.entries(filters)) {
      if (value !== null && value !== undefined && value !== '') {
        params = params.set(key, String(value));
      }
    }
    return this.http.get<CriticalCasePage>(this.base(), { params });
  }

  severities(): Observable<CriticalCaseSeverity[]> {
    return this.http.get<CriticalCaseSeverity[]>(`${this.base()}/gravidades`);
  }

  get(id: number): Observable<CriticalCaseDetail> {
    return this.http.get<CriticalCaseDetail>(`${this.base()}/${id}`);
  }
}
